export const TestIds = {
  root: 'login-social-button-root',
  link: 'login-social-button-link',
  icon: 'login-social-button-icon',
  badge: 'login-social-button-badge',
};
